import cookies from 'browser-cookies';
import axios from 'axios';
import {clearUser, showErrMsg} from './util';

const ERR_OK = '200';
const ERR_TIME_OUT = '4';

export default function fetch(code, param = {}, mode, isBlob) {
    const url = '/api' + code;

    const data = {
        ...param
    };

    param = JSON.stringify(data);
    return axios({
        method: mode === 'get' ? 'get' : 'post',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': cookies.get('termite-sys-token') || '',
            'responseType': isBlob ? 'blob' : ''
        },
        url: url,
        data: param
    }).then((res) => {
        res = res.data;
        if (res.errorCode === ERR_TIME_OUT) {
            logout();
            return Promise.reject('timeout');
        }
        // token 过期
        if (res.errorCode === 'A50003') {
            logout();
            return Promise.reject('timeout');
        }
      // token 错误
      if (res.errorCode === '300000') {
        logout();
        return Promise.reject('timeout');
      }
        // 用户认证失败
        if (res.errorCode === 'A50004') {
            logout(res.errorMsg);
            return Promise.reject('timeout');
        }
        if (res.code !== ERR_OK) {
            if (res.errorMsg) {
                showErrMsg(res.errorMsg.toString());
            } else {
                if(!res) {
                    showErrMsg('操作失败');
                }
            }
            return Promise.reject(res);
        }
        return Promise.resolve(res.data);
    });
}

export function logout(msg = '登录失效，请重新登录!') {
    clearUser();
    showErrMsg(msg);
    if (window.location.href.indexOf('/login') > -1) {
        setTimeout(() => {
            window.location.href = '/login';
        }, 800);
    }
}
